import 'tradera/legacy/static/app/';
